







import Vue from 'vue'
import { Emit, Component } from 'vue-property-decorator'

@Component({})
export default class PgaSaveButton extends Vue{
    buttons = {
		save: {
			Icon: "mdi-check-circle",
            Text: "Save",
		}
    }
    
    @Emit("click")
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    clicked() : void { }
}
